export enum WebsocketFeedType {
  EVENTS = 'events',
  STATISTICS = 'statistics',
  BOXSCORE = 'boxscore',
}
